export const getScrollbarWidth = () => {
    const outer = document.createElement("div");
    outer.className = 'myCustomScroll';
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    outer.style.msOverflowStyle = "scrollbar"; // needed for WinJS apps

    document.body.appendChild(outer);

    const widthNoScroll = outer.offsetWidth;
    // force scrollbars
    outer.style.overflow = "scroll";

    // add innerdiv
    const inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);

    const widthWithScroll = inner.offsetWidth;

    // remove divs
    if (outer && outer.parentNode) {
        outer.parentNode.removeChild(outer);
    }
    return widthNoScroll - widthWithScroll;
};

export const removeDuplicates = (originalArray: Array<any>, prop: string) => {
    const newArray = [];
    const lookupObject = {};

    for (const i in originalArray) {
        lookupObject[originalArray[i][prop]] = originalArray[i];
    }

    for (const i in lookupObject) {
        newArray.push(lookupObject[i]);
    }
    return newArray;
};

export const getCurrentDate = () => {
    const today = new Date();
    let dd = `${today.getDate()}`;
    let mm = `${today.getMonth() + 1}`;
    const yyyy = today.getFullYear();
    if (+dd < 10) {
        dd = '0' + dd;
    }
    if (+mm < 10) {
        mm = '0' + mm;
    }
    return `${yyyy}-${mm}-${dd}`;
};

export const toggleDragginClass = (isDragging: boolean) => {
    if (isDragging) {
        document.body.classList.add('is-drag');
    } else {
        document.body.classList.remove('is-drag');
    }
};



// WEBPACK FOOTER //
// ./src/lib/helpers.ts